import { useCallback, useMemo, useState } from 'react';
import { OPEN_PORTAL_USERS_PANEL } from 'crm-events-data';
import PortalUsersPanelAsync from '../crm_ui/timeline/components/generic/header/PortalUsersPanelAsync';
import { jsx as _jsx } from "react/jsx-runtime";
export const usePortalUsersPanelActionHandler = () => {
  const [hubId, setHubId] = useState(null);
  const handlePortalUsersPanelAction = useCallback((actionType, data) => {
    if (actionType === OPEN_PORTAL_USERS_PANEL) {
      setHubId(data.hubId);
    }
  }, [setHubId]);
  const handleClosePanelClick = useCallback(() => {
    setHubId(null);
  }, [setHubId]);
  const portalUsersPanel = useMemo(() => {
    if (!hubId) {
      return null;
    }
    return /*#__PURE__*/_jsx(PortalUsersPanelAsync, {
      "data-unit-test": "portal-users-panel",
      hubId: hubId,
      onClose: handleClosePanelClick
    });
  }, [handleClosePanelClick, hubId]);
  return {
    handlePortalUsersPanelAction,
    portalUsersPanel
  };
};